import { render, staticRenderFns } from "./ClientProfileCharges.vue?vue&type=template&id=64a358c5&scoped=true&"
import script from "./ClientProfileCharges.vue?vue&type=script&lang=js&"
export * from "./ClientProfileCharges.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileCharges.vue?vue&type=style&index=0&id=64a358c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a358c5",
  null
  
)

export default component.exports